/**
 * External dependencies
 */
import React from 'react';
import classNames from 'classnames';
import { Box } from '@towersystems/towersystems-design-system';

/**
 * Internal dependencies
 */
import Divider from './divider';

/**
 * Style dependencies
 */
import './styles.scss';

const ButtonGroup = ({ children, stackItemComponent = 'div', className, dividers, space, ...rest }) => {
	const classes = classNames('button-group', className);
    const stackClasses = classNames('');
	const stackItems = React.Children.toArray(children);
	return (
		<Box display='flex' className={classes} {...rest}>
			{stackItems.map((child, index) => (
				<Box display='flex' component={stackItemComponent} key={index} className={stackClasses}>
					{dividers && index > 0 ? (
                        <Box style={{ height: "100%" }} paddingX={space} marginX={space}>
							<Divider />
						</Box>
					) : null}
					{child}
				</Box>
			))}
		</Box>
	);
};

export default ButtonGroup;
